import React from 'react'
import { Row, Col } from 'react-bootstrap'
import classnames from 'classnames'
import i18next from 'i18next'
import { Map, Range, List } from 'immutable'

import ProgressBar from './ProgressBar'
import ProgressCounter from './ProgressCounter'
import Loading from './Loading'
import QuestionnaireError from './smart/QuestionnaireErrorContainer'
import QuestionnaireThankYou from './QuestionnaireThankYou'
import { Wopi360OpenQuestion } from './Wopi360OpenQuestion'

import styles from './styles/questionnaire.scss'

export default class Wopi360Questions extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      answers: Map(),
      openAnswers: Map()
    }
  }

  render() {
    const { questions, openQuestions, activeQuestionIndex, language, isTarget } = this.props

    if (questions.isEmpty()) {
      return <Loading />
    }

    const flattenedQuestions = this.getFlattenedQuestions()
    const currentQuestions = this.getCurrentQuestions()
    const openQuestionsPagesCount = 1

    const maxProgress = questions.count() + (isTarget ? 0 : openQuestionsPagesCount)

    let progress = maxProgress

    if (currentQuestions) {
      progress =
        questions.findIndex(
          categoryAnswers => categoryAnswers.category === currentQuestions.category
        ) + 1
    }

    const totalQuestionsCount = flattenedQuestions.count() + (isTarget ? 0 : openQuestions.count())

    const renderPage = content => (
      <section>
        <QuestionnaireError />

        {content}

        <ProgressBar current={activeQuestionIndex} max={totalQuestionsCount} />

        <ProgressCounter current={progress} max={maxProgress} />
      </section>
    )

    if (activeQuestionIndex < flattenedQuestions.count()) {
      return renderPage(this.renderQuestions())
    }

    if (!isTarget) {
      const answeredOpenQuestionsCount = openQuestions.filter(q => q.answer).size
      const openQuestionsCount = openQuestions.size

      if (answeredOpenQuestionsCount < openQuestionsCount) {
        return renderPage(this.renderOpenQuestions())
      }
    }

    return (
      <QuestionnaireThankYou
        language={language}
        refreshQuestionnaire={this.props.refreshQuestionnaire}
      />
    )
  }

  getFlattenedQuestions() {
    return this.props.questions.reduce((acc, categoryAnswers) => {
      return categoryAnswers.answers.reduce((a, answer) => {
        return a.push(answer)
      }, acc)
    }, List())
  }

  getCurrentQuestions() {
    const { questions, activeQuestionIndex } = this.props

    const activeQuestion = this.getFlattenedQuestions()
      .skip(activeQuestionIndex)
      .take(1)
      .first()

    return activeQuestion
      ? questions.find(categoryAnswers =>
          categoryAnswers.answers.find(answer => answer.id === activeQuestion.id)
        )
      : null
  }

  renderQuestions() {
    const { language } = this.props

    const currentQuestions = this.getCurrentQuestions()

    const t = text => i18next.t(text, { lng: language, ns: 'wopi360Test' })

    return (
      <div className={styles.wopi360Questionnaire}>
        <Row>
          <Col md={12}>
            <table className={classnames('table', styles.likert)}>
              <tbody>
                <tr className="hidden-xs">
                  <th className={styles.likertCategory}>{t(currentQuestions.category)}</th>

                  {Range(1, 8).map(answer => (
                    <th key={answer}>
                      <span>{answer}</span> {t(`answer_${answer}`)}
                    </th>
                  ))}
                </tr>

                {currentQuestions.answers.map((question, i) => (
                  <tr key={i}>
                    <td>{i18next.t(question.id, { lng: language, ns: 'wopi360Questions' })}</td>

                    {Range(1, 8).map(answer => (
                      <td key={answer} onClick={this.handleAnswer(question.id, answer)}>
                        <input
                          type="radio"
                          id={`q${question.id}-${answer}`}
                          name={`q${question.id}`}
                          value={answer}
                          checked={
                            this.state.answers.has(question.id) &&
                            this.state.answers.get(question.id) === answer
                          }
                        />

                        <label htmlFor={`q${question.id}-${answer}`}>
                          <span className={classnames(styles.labelText, 'visible-xs')}>
                            {t(`answer_${answer}`)}
                          </span>
                        </label>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        </Row>

        <div className={styles.wopi360QuestionElement}>
          <button
            className={styles.button}
            disabled={!currentQuestions.answers.every(q => this.state.answers.has(q.id))}
            onClick={this.handleNextClick}
          >
            {t('continue')}
          </button>
        </div>

        <div className={classnames(styles.questionElement, styles.questionAnswerButtons)} />
      </div>
    )
  }

  renderOpenQuestions() {
    const { openQuestions, language } = this.props
    const translatedText = text => i18next.t(text, { lng: language, ns: 'wopi360Test' })

    return (
      <div>
        <Row>
          {openQuestions.map(question => {
            return (
              <Wopi360OpenQuestion
                key={question.id}
                questionTitle={translatedText(`open_answer_${question.id}`)}
                questionDescription={translatedText(`open_answer_${question.id}_description`)}
                value={this.state.openAnswers.get(question.id)}
                question={question}
                language={language}
                onChange={this.handleOpenAnswerChange}
              />
            )
          })}
        </Row>

        <div className={styles.wopi360QuestionElement}>
          <button
            className={styles.button}
            disabled={
              !openQuestions.every(q => {
                if (!this.state.openAnswers.has(q.id)) {
                  return false
                } else {
                  const answer = this.state.openAnswers.get(q.id)
                  return answer && answer.length > 0
                }
              })
            }
            onClick={this.handleOpenAnswersNextClick}
          >
            {translatedText('complete')}
          </button>
        </div>

        <div className={classnames(styles.questionElement, styles.questionAnswerButtons)} />
      </div>
    )
  }

  handleAnswer = (questionId, answer) => () => {
    this.setState({ answers: this.state.answers.update(questionId, () => answer) })
  }

  handleNextClick = () => {
    window.scroll && window.scroll(0, 0)

    this.props.onAnswer(this.state.answers)
  }

  handleOpenAnswersNextClick = () => {
    this.props.onOpenAnswer(this.state.openAnswers)
  }

  handleOpenAnswerChange = questionId => e => {
    this.setState({
      openAnswers: this.state.openAnswers.update(questionId, () => e.target.value)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360Questions.js